/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { SeHouseholdSetupDataAccessStoreModule } from '@se-po/se-household-setup-data-access-store'
import { SeHouseholdSetupFeatureAccountInfoModule } from '@se-po/se-household-setup-feature-account-info'
import { SeHouseholdSetupFeatureAlreadyHaveAccountModule } from '@se-po/se-household-setup-feature-already-have-account'
import { SeHouseholdSetupFeatureChildContactInfoDocsModule } from '@se-po/se-household-setup-feature-child-contact-info'
import { SeHouseholdSetupFeatureChildInfoDocsModule } from '@se-po/se-household-setup-feature-child-info'
import { SeHouseholdSetupFeatureCreatePasswordModule } from '@se-po/se-household-setup-feature-create-password'
import { SeHouseholdSetupFeatureInviteModule } from '@se-po/se-household-setup-feature-guardian-invite'
import { SeHouseholdSetupFeatureMatchModule } from '@se-po/se-household-setup-feature-match'
import { SeHouseholdSetupFeatureParentGuardianInfoDocsModule } from '@se-po/se-household-setup-feature-parent-guardian-info'
import { SeHouseholdSetupFeatureReviewModule } from '@se-po/se-household-setup-feature-review'
import { SeHouseholdSetupFeatureSelfInfoDocsModule } from '@se-po/se-household-setup-feature-self-info'
import { SeHouseholdSetupFeatureVerificationModule } from '@se-po/se-household-setup-feature-verification'
import { SeHouseholdSetupFeatureWhosParticipatingDocsModule } from '@se-po/se-household-setup-feature-whos-participating'

import { environment } from '@se-po/shared-environments'
import { SeFeApiModule } from 'se-fe-api'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsCodeModule } from 'se-fe-docs-code'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'

import { TranslateModule } from '@ngx-translate/core'
import { SeHouseholdSetupFeatureUnsubscribeSuccessDocsModule } from '@se-po/se-household-setup-feature-unsubscribe-success'
import { OverviewComponent } from './overview/overview.component'
import { PROVIDERS } from './providers'
import { SeHouseholdSetupDocsRoutingModule } from './se-household-setup-docs-routing.module'
import { SeHouseholdSetupDocsComponent } from './se-household-setup-docs.component'
import { SeHouseholdSetupFeatureMfaAppCodesModule } from '@se-po/se-household-setup-feature-mfa-app-codes'


@NgModule({
  declarations: [
    SeHouseholdSetupDocsComponent,
    OverviewComponent
  ],
  imports: [
    CommonModule,
    SeFeApiModule.forRoot({
      domainEnvironments: environment.domainEnvironments,
    }),
    SeHouseholdSetupDataAccessStoreModule,
    SeHouseholdSetupFeatureAccountInfoModule,
    SeHouseholdSetupFeatureAlreadyHaveAccountModule,
    SeHouseholdSetupFeatureChildContactInfoDocsModule,
    SeHouseholdSetupFeatureChildInfoDocsModule,
    SeHouseholdSetupFeatureCreatePasswordModule,
    SeHouseholdSetupFeatureInviteModule,
    SeHouseholdSetupFeatureMatchModule,
    SeHouseholdSetupFeatureMfaAppCodesModule,
    SeHouseholdSetupFeatureParentGuardianInfoDocsModule,
    SeHouseholdSetupFeatureSelfInfoDocsModule,
    SeHouseholdSetupFeatureReviewModule,
    SeHouseholdSetupFeatureUnsubscribeSuccessDocsModule,
    SeHouseholdSetupFeatureVerificationModule,
    SeHouseholdSetupFeatureWhosParticipatingDocsModule,
    SeHouseholdSetupDocsRoutingModule,
    SeFeCardModule,
    SeFeDocsCodeModule,
    SeFeHeaderModule,
    SeFePageModule,
    TranslateModule.forChild()
  ],
  exports: [OverviewComponent],
  providers: PROVIDERS,
})
export class SeHouseholdSetupDocsModule {}
